import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './Grid.styles.js';

var getGridClasses = function getGridClasses(_ref) {
  var _cleanupClassObject;
  var className = _ref.className,
    spacing = _ref.spacing,
    gallerySliderSpacing = _ref.gallerySliderSpacing,
    gallerySlider = _ref.gallerySlider,
    centeredLayout = _ref.centeredLayout;
  return cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(hostClass), true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__gallery-slider-spacing"), gallerySliderSpacing), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__gallery-slider"), gallerySlider), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__").concat(spacing), !!spacing), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__centered"), centeredLayout), _cleanupClassObject));
};
var GridPresentation = fComp(function (_a) {
  var id = _a.id,
    children = _a.children,
    otherProps = __rest(_a, ["id", "children"]);
  return /*#__PURE__*/React.createElement(Host, {
    className: getGridClasses(otherProps),
    id: id
  }, children);
});
GridPresentation.displayName = "GridPresentation";

export { GridPresentation, getGridClasses };
